import { TranslocoService } from '@jsverse/transloco';
import { InjectorHelper } from '@olymp/shared';
import { ConfirmationService } from 'primeng/api';

export function Confirmable(
  confirmText = 'Are you sure that you want to proceed?',
  extraContent?: string,
) {
  return (
    target: object,
    propertyName: string,
    descriptor: PropertyDescriptor,
  ) => {
    // Store Original Method Implemetation
    const originalMethod = descriptor.value;
    const $confirmation = InjectorHelper.injector.get(ConfirmationService);
    const transloco = InjectorHelper.injector.get(TranslocoService);

    descriptor.value = function (...args: any[]) {
      $confirmation.confirm({
        message: transloco.translate(confirmText),
        header: transloco.translate('Confirmation'),
        closable: true,
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectButtonProps: {
          label: transloco.translate('Cancel'),
          severity: 'secondary',
          outlined: true,
        },
        acceptButtonProps: {
          label: transloco.translate('confirm'),
        },
        accept: () => {
          const result = originalMethod.apply(this, args);
          return result;
        },
        reject: () => {
          return;
        },
      });
    };
    return descriptor;
  };
}
